













































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import * as def from "@/definitions";

import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { GroupLayer } from "@/model/document2/page/surface/design/layer/groupLayer";

import { Treenode } from "@/definitions/treenode"

//icon.vue
import ObjTextSelected from "../resources/objTextSelected.vue"
import ObjCustomTextSelected from "../resources/objCustomTextSelected.vue"
import ObjImageSelected from "../resources/objImageSelected.vue"
import ObjPolygonSelected from "../resources/objPolygonSelected.vue"
import ObjLineSelected from "../resources/objLineSelected.vue"
import ObjCurveSelected from "../resources/objCurveSelected.vue"
import ObjQrcodeSelected from "../resources/objQrcodeSelected.vue"
import ObjBarcodeSelected from "../resources/objBarcodeSelected.vue"
import ObjNumberSelected from "../resources/objNumberSelected.vue"
import ObjTableSelected from "../resources/objTableSelected.vue"
import ObjCalendarSelected from "../resources/objCalendarSelected.vue"
import LockIconSelected from "../resources/lockIconSelected.vue"

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
      ObjTextSelected,
      ObjCustomTextSelected,
      ObjImageSelected,
      ObjPolygonSelected,
      ObjLineSelected,
      ObjCurveSelected,
      ObjQrcodeSelected,
      ObjBarcodeSelected,
      ObjNumberSelected,
      ObjTableSelected,
      ObjCalendarSelected,
      LockIconSelected
  }
})
export default class SingleLayerView extends Vue {
    
  @Prop()
  private treeNode!: Treenode;
  @Prop()
  private renameId!: number;

  isInputVisible = false;

  canSubmit = false;

  @Watch("renameId")
  rename(){
      if(this.renameId == this.treeNode.data.id){
          this.editTitle()
      }
  }

  editTitle(){
    this.isInputVisible = true
    this.$nextTick(()=>{
        let input = this.$refs.inputTitle as HTMLInputElement
        input.select()
    })
    this.$emit("editTitle", this.treeNode)
  }

  decideTitle(title , blur){
      if(blur || this.canSubmit){
          this.$nextTick(()=>{
            setTimeout(()=>{
                this.isInputVisible = false;
                this.$emit("decideTitle" , this.treeNode , title);
                this.canSubmit = false;
                if(!blur){
                    let inputTitle = this.$refs.inputTitle as HTMLInputElement;
                    inputTitle.blur()
                }
            } , 100)
        }) 
      }
  }

  onClickNode(event){
    
    // 右クリックはキャンセルする
    if(event.button == 2) return;

      this.isGrabbing = true

    if (event.shiftKey) this.selectMultipleNodes()
    else this.selectSingleNode()
  }

  selectSingleNode(){
      this.$emit("selectSingleNode" , this.treeNode)
  }

  selectMultipleNodes(){
      this.$emit("selectMultipleNodes" , this.treeNode)
  }

  onClickRight(event){
    this.$emit("onClickRight" , this.treeNode , event)
  }

isGrabbing = false
  onGrabNode(event){
      if(this.isGrabbing){
          this.$emit("onGrabNode" , this.treeNode , event)
      }
  }

  get nodeStyle(){
    let minus = 16 * this.treeNode.data.hierarchy + "px"

    return {
        "width" : "calc(100% - " + minus + ")"
    }
  }

  get selectedTitleStyle(){
      if(this.treeNode.isSelected){
          return {
              color : this.$store.getters.userConfigColors.buttonColorCode
          }
      }
      return
  }

  getResource(file : string){
        return ResourceHelper.getResource(file);
    }
  
}
